import { IFirstSupplyDetails } from '../../models';
import * as DateUtils from 'utils/dates';

interface FirstSupplyDetailsFormDefaultValues {
  firstSupplyDetails_dateOfFirstSupply: string | null;
}

export function handleFirstSupplyFormDefaultValues(
  first_supply_details: IFirstSupplyDetails
): FirstSupplyDetailsFormDefaultValues {
  return {
    firstSupplyDetails_dateOfFirstSupply:
      first_supply_details && first_supply_details.first_supply_date
        ? `${first_supply_details.first_supply_date}`
        : null,
  };
}
